import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Belgaumtopanindiacabservice() {



    const cardData = {




keyword: "Belgaum to Pan India Cab Service",

headingDescription: "Belgaum Taxi Service provides reliable Pan India cab services from Belgaum for customers looking for comfortable, safe, and convenient long-distance travel across India. We offer one-way taxi, round-trip cab, multi-city travel, corporate transportation, family trips, airport transfers, and customized outstation cab solutions from Belgaum to major cities and tourist destinations across the country. Our extensive fleet includes Sedan, Swift Dzire, Ertiga, SUV, Innova, Innova Crysta, Tempo Traveller, and premium cars suitable for individuals, families, corporate travelers, and large groups. With professional drivers, well-maintained vehicles, doorstep pickup, flexible travel schedules, transparent pricing, easy booking, and 24/7 customer support, we ensure a smooth and comfortable journey. Whether you are traveling for business meetings, vacations, pilgrimage tours, medical requirements, educational purposes, relocation, or interstate travel, Belgaum Taxi Service provides dependable Pan India taxi solutions with complete travel convenience. Our experienced chauffeurs ensure safe highway journeys, timely service, and comfortable rides to destinations across Karnataka, Maharashtra, Goa, Tamil Nadu, Kerala, Telangana, Andhra Pradesh, Gujarat, Rajasthan, Delhi, and other parts of India.",

topPlaces: [
  {
    title: "Bangalore",
    description: "Bangalore is India's leading IT and business hub known for technology parks, corporate offices, startups, educational institutions, shopping destinations, and entertainment centers. It is one of the most frequently requested destinations for corporate and personal cab travel from Belgaum."
  },
  {
    title: "Mumbai",
    description: "Mumbai is India's financial capital famous for business districts, airports, Bollywood, tourist attractions, and commercial centers. Belgaum Taxi Service provides comfortable long-distance cab connectivity for travelers visiting Mumbai for business, family, and personal requirements."
  },
  {
    title: "Pune",
    description: "Pune is a major IT, education, and industrial city in Maharashtra known for corporate offices, technology parks, universities, and cultural attractions. Private cab services are preferred by travelers looking for convenient interstate travel from Belgaum."
  },
  {
    title: "Goa",
    description: "Goa is one of India's most popular holiday destinations known for beautiful beaches, resorts, churches, nightlife, and water activities. Families, couples, and groups prefer private cabs from Belgaum for comfortable Goa vacations."
  },
  {
    title: "Hyderabad",
    description: "Hyderabad is a major technology and business destination known for IT companies, corporate offices, historical attractions, and famous landmarks. It is a popular destination for business travelers and families from Karnataka."
  },
  {
    title: "Chennai",
    description: "Chennai is an important metropolitan city known for automobile industries, IT companies, beaches, temples, healthcare facilities, and cultural heritage. Long-distance cab services provide comfortable connectivity for travelers."
  },
  {
    title: "Delhi",
    description: "Delhi is India's capital city known for government offices, business centers, historical monuments, airports, and major tourist attractions. Private cab services offer convenient interstate travel for families and corporate travelers."
  },
  {
    title: "Jaipur",
    description: "Jaipur is a famous heritage city in Rajasthan known for forts, palaces, royal architecture, and cultural attractions. It is a popular destination for travelers planning extended India tours."
  },
  {
    title: "Kerala",
    description: "Kerala is known for backwaters, beaches, hill stations, wildlife, and scenic landscapes. Travelers choose private cab services for comfortable sightseeing tours across Kerala destinations with flexible travel plans."
  },
  {
    title: "Ahmedabad",
    description: "Ahmedabad is a major business and industrial city in Gujarat known for commercial hubs, textile industries, historical attractions, and modern infrastructure. It is a preferred destination for business and family travel."
  }
],




  "services": [
    {
      "name": "Belgaum to Pan India Cab Service",
      "description": "Book Belgaum to Pan India Cab Service for safe, comfortable, and reliable long-distance travel across India. Get professional chauffeurs, well-maintained AC vehicles, and multiple cab options including Sedan, Ertiga, Innova Crysta, and SUV for business trips, family journeys, airport transfers, and nationwide travel needs."
    },
    {
      "name": "Pan India Cab Service from Belgaum",
      "description": "Choose Pan India Cab Service from Belgaum for convenient and hassle-free transportation to any destination across India. Enjoy reliable chauffeur-driven vehicles, flexible booking options, affordable fares, and comfortable travel solutions for personal and corporate requirements."
    },
    {
      "name": "Belgaum Outstation Cab Service",
      "description": "Hire Belgaum Outstation Cab Service for smooth and comfortable long-distance journeys with experienced drivers and premium vehicles. Our outstation cabs are suitable for family trips, business travel, sightseeing tours, and interstate travel."
    },
    {
      "name": "Belgaum All India Taxi Service",
      "description": "Book Belgaum All India Taxi Service for reliable nationwide transportation with professional drivers and well-maintained cars. Travel anywhere in India with flexible one way and round trip taxi options designed for your convenience."
    },
    {
      "name": "Belgaum Long Distance Cab",
      "description": "Choose Belgaum Long Distance Cab for safe and comfortable interstate travel. Enjoy spacious seating, clean AC vehicles, skilled chauffeurs, and affordable packages for extended journeys across different cities in India."
    },
    {
      "name": "Belgaum One Way Cab",
      "description": "Book Belgaum One Way Cab for economical single-trip travel without return charges. Get fixed pricing, comfortable vehicles, professional drivers, and convenient pickup options for your one direction journey."
    },
    {
      "name": "Belgaum Round Trip Taxi",
      "description": "Hire Belgaum Round Trip Taxi for convenient return journeys with flexible travel schedules and affordable packages. Perfect for family vacations, business visits, sightseeing, and personal travel requirements."
    },
    {
      "name": "Belgaum Cab Booking",
      "description": "Complete Belgaum Cab Booking online with easy reservations, quick confirmation, and multiple vehicle choices. Select Sedan, Ertiga, Innova Crysta, or SUV cabs according to your travel needs."
    },
    {
      "name": "Belgaum Taxi Booking",
      "description": "Reserve Belgaum Taxi Booking services for comfortable and reliable transportation with experienced chauffeurs. Get affordable taxi options with flexible timing and doorstep pickup facilities."
    },
    {
      "name": "Belgaum Car Rental",
      "description": "Choose Belgaum Car Rental for private chauffeur-driven vehicles with comfortable interiors and professional service. Ideal for local travel, outstation trips, corporate journeys, and family transportation."
    },
    {
      "name": "Belgaum Outstation Taxi",
      "description": "Hire Belgaum Outstation Taxi for safe and convenient long-distance travel. Enjoy clean AC cars, experienced drivers, transparent pricing, and flexible travel packages for interstate journeys."
    },
    {
      "name": "Belgaum Innova Crysta Cab",
      "description": "Book Belgaum Innova Crysta Cab for premium and spacious travel with luxury seating, large luggage capacity, and professional chauffeurs. Perfect for family groups, corporate travel, and comfortable long-distance journeys."
    },
    {
      "name": "Belgaum Ertiga Cab",
      "description": "Choose Belgaum Ertiga Cab for affordable 6 to 7 seater travel with spacious interiors and comfortable seating. Ideal for family trips, group travel, airport transfers, and outstation journeys."
    },
    {
      "name": "Belgaum Sedan Cab",
      "description": "Book Belgaum Sedan Cab for economical and comfortable travel with clean AC vehicles and trained drivers. Suitable for individuals, couples, business trips, and smooth highway transportation."
    },
    {
      "name": "Belgaum SUV Cab",
      "description": "Hire Belgaum SUV Cab for spacious and comfortable travel with premium vehicles and experienced chauffeurs. Perfect for group journeys, family tours, and long-distance road trips."
    },
    {
      "name": "Belgaum Private Taxi",
      "description": "Reserve Belgaum Private Taxi for a personalized travel experience with dedicated vehicles and professional drivers. Enjoy privacy, comfort, and hassle-free transportation for all types of journeys."
    },
    {
      "name": "Cheap Belgaum Cab Service",
      "description": "Find Cheap Belgaum Cab Service offering affordable fares without compromising safety and comfort. Get reliable vehicles, skilled drivers, and budget-friendly travel solutions for local and outstation trips."
    },
    {
      "name": "Best Belgaum Taxi Service",
      "description": "Choose the Best Belgaum Taxi Service with premium vehicles, trained chauffeurs, competitive pricing, and dependable customer support. Experience safe and comfortable travel for every journey."
    },
    {
      "name": "Online Belgaum Cab Booking",
      "description": "Complete Online Belgaum Cab Booking with simple reservations, instant confirmation, and flexible travel options. Select your preferred vehicle and enjoy convenient doorstep pickup service."
    },
    {
      "name": "Belgaum Taxi Fare",
      "description": "Check Belgaum Taxi Fare for affordable and transparent pricing with no hidden charges. Get comfortable taxis with professional drivers for safe and economical travel."
    },
    {
      "name": "Belgaum Car Hire",
      "description": "Hire Belgaum Car Hire services for comfortable private transportation with chauffeur-driven vehicles. Choose from multiple car categories for personal, family, corporate, and outstation travel."
    },
    {
      "name": "Belgaum Cab Price",
      "description": "Get affordable Belgaum Cab Price with flexible packages for one way and round trips. Enjoy quality vehicles, reliable service, and professional drivers at competitive rates."
    },
    {
      "name": "Belgaum Family Cab",
      "description": "Book Belgaum Family Cab for safe and comfortable family travel with spacious vehicles and experienced chauffeurs. Perfect for vacations, family functions, and long-distance journeys."
    },
    {
      "name": "Belgaum Corporate Taxi",
      "description": "Choose Belgaum Corporate Taxi services for business travel, employee transportation, and executive journeys. Get punctual service with professional drivers and well-maintained vehicles."
    },
    {
      "name": "Belgaum Airport Transfer",
      "description": "Book Belgaum Airport Transfer services for timely airport pickup and drop with comfortable vehicles and professional chauffeurs. Enjoy stress-free airport transportation with reliable cab availability."
    },
    {
      "name": "Belgaum Cab Fare",
      "description": "Get the best Belgaum Cab Fare with affordable travel packages and transparent pricing. Travel comfortably with Sedan, Ertiga, Innova Crysta, and SUV cab options."
    },
    {
      "name": "Belgaum Taxi Near Me",
      "description": "Find Belgaum Taxi Near Me for quick and reliable cab availability with professional drivers. Enjoy convenient booking, doorstep pickup, and comfortable travel anytime."
    },
    {
      "name": "Belgaum Travel by Cab",
      "description": "Experience comfortable Belgaum Travel by Cab with reliable transportation, professional drivers, and premium vehicle options. Enjoy smooth journeys with customized travel solutions across India."
    },
    {
      "name": "All India Taxi from Belgaum",
      "description": "Book All India Taxi from Belgaum for nationwide travel with experienced chauffeurs and comfortable vehicles. Get reliable taxi services for interstate trips, family tours, business travel, and long-distance journeys."
    }
  ],
  "tableData": [
    ["Belgaum to Pan India Cab Service", "Pan India Cab Service from Belgaum"],
    ["Belgaum Outstation Cab Service", "Belgaum All India Taxi Service"],
    ["Belgaum Long Distance Cab", "Belgaum One Way Cab"],
    ["Belgaum Round Trip Taxi", "Belgaum Cab Booking"],
    ["Belgaum Taxi Booking", "Belgaum Car Rental"],
    ["Belgaum Outstation Taxi", "Belgaum Innova Crysta Cab"],
    ["Belgaum Ertiga Cab", "Belgaum Sedan Cab"],
    ["Belgaum SUV Cab", "Belgaum Private Taxi"],
    ["Cheap Belgaum Cab Service", "Best Belgaum Taxi Service"],
    ["Online Belgaum Cab Booking", "Belgaum Taxi Fare"],
    ["Belgaum Car Hire", "Belgaum Cab Price"],
    ["Belgaum Family Cab", "Belgaum Corporate Taxi"],
    ["Belgaum Airport Transfer", "Belgaum Cab Fare"],
    ["Belgaum Taxi Near Me", "Belgaum Travel by Cab"],
    ["All India Taxi from Belgaum", ""]
  ],





whychoose: [
  {
    WhyChooseheading: "Reliable Belgaum to Pan India Cab Service",
    WhyChoosedescription: "Travel anywhere across India from Belgaum with a dependable outstation taxi service offering comfortable vehicles, professional drivers, and customized travel solutions."
  },
  {
    WhyChooseheading: "Nationwide Travel Connectivity",
    WhyChoosedescription: "Our Pan India cab service connects Belgaum with major cities, tourist destinations, business hubs, and remote locations with convenient pickup and drop facilities."
  },
  {
    WhyChooseheading: "Wide Range of Vehicle Options",
    WhyChoosedescription: "Choose from Sedan, Swift Dzire, Ertiga, Innova, Innova Crysta, SUV, Tempo Traveller, and other vehicles based on your travel group and comfort needs."
  },
  {
    WhyChooseheading: "Ideal for Long Distance Journeys",
    WhyChoosedescription: "Whether it is a family vacation, corporate travel, pilgrimage tour, relocation journey, or personal trip, our cabs provide a comfortable travel experience."
  },
  {
    WhyChooseheading: "Experienced Drivers Across Routes",
    WhyChoosedescription: "Professional chauffeurs with route knowledge ensure safe, smooth, and convenient travel across different states and destinations in India."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Plans",
    WhyChoosedescription: "Select one-way drop services, return trips, multi-city travel, or customized packages according to your travel requirements."
  },
  {
    WhyChooseheading: "Comfortable Travel with Quality Service",
    WhyChoosedescription: "Well-maintained vehicles, clean interiors, and reliable support make long-distance journeys from Belgaum comfortable and stress-free."
  },
  {
    WhyChooseheading: "Easy Booking for Any Destination",
    WhyChoosedescription: "Get assistance with route planning, vehicle selection, fare details, and booking confirmation for your Belgaum to Pan India cab requirement."
  }
]

};

const faqData = [
  {
    question: "Does Belgaum Taxi Service provide Belgaum to Pan India Cab Service?",
    answer: "Yes, we provide Pan India cab services from Belgaum to various cities and destinations across India with comfortable vehicles and professional drivers."
  },
  {
    question: "Can I book a one-way cab from Belgaum to another city in India?",
    answer: "Yes, one-way outstation cab services are available for direct travel to your preferred destination."
  },
  {
    question: "Which vehicles are available for Pan India travel?",
    answer: "You can choose from Sedan, Swift Dzire, Ertiga, Innova, Innova Crysta, SUV, Tempo Traveller, and other suitable vehicles."
  },
  {
    question: "Is Pan India cab service suitable for family trips?",
    answer: "Yes, spacious vehicles are available for families, groups, senior citizens, and long-distance holiday journeys."
  },
  {
    question: "Can I book a multi-city travel package?",
    answer: "Yes, customized multi-city and multi-day travel packages can be arranged according to your itinerary."
  },
  {
    question: "Do you provide airport and railway station pickup?",
    answer: "Yes, pickup and drop facilities are available from airports, railway stations, hotels, homes, and other preferred locations."
  },
  {
    question: "Can I hire a private taxi for corporate travel?",
    answer: "Yes, private cab services are available for business meetings, employee travel, site visits, and corporate requirements."
  },
  {
    question: "Are toll and parking charges included in the fare?",
    answer: "Toll, parking, permits, and other applicable charges depend on the selected travel package and are explained during booking."
  },
  {
    question: "Is Belgaum to Pan India taxi service available 24/7?",
    answer: "Yes, booking assistance is available for planned journeys as well as urgent travel requirements."
  },
  {
    question: "How can I book a Belgaum to Pan India Cab?",
    answer: "Share your destination, travel date, pickup location, passenger details, and preferred vehicle type to receive suitable fare details and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Ajay Desai",
    feedback: "We booked a long-distance cab from Belgaum for an outstation trip and had a comfortable experience. The driver was professional and the vehicle was excellent.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Kavita Patil",
    feedback: "The Pan India cab service helped us plan our family journey easily. The booking process was simple, and the overall travel experience was very smooth.",
    rating: 5
  }
];


    const Images = [
        { place: "/images/keyword/1.jpg", text: "Cab Service in Belgaum", link: "Cab-Service-in-Belgaum" },
        { place: "/images/keyword/2.jpg", text: "Belgaum Taxi Service", link: "Belgaum-Taxi-Service" },
        { place: "/images/keyword/3.jpg", text: "Belgaum to Goa Cab", link: "Belgaum-to-Goa-Cab" },
        { place: "/images/keyword/4.jpg", text: "Belgaum to Mahabaleshwar Cab", link: "Belgaum-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/5.jpg", text: "Belgaum to Kerala Cab Service", link: "Belgaum-to-Kerala-Cab-Service" },
        { place: "/images/keyword/6.jpg", text: "Goa to Belgaum Cab", link: "Goa-to-Belgaum-Cab" },
        { place: "/images/keyword/7.jpg", text: "Belgaum to Mumbai Cab", link: "Belgaum-to-Mumbai-Cab" },
        { place: "/images/keyword/8.jpg", text: "Belgaum to Bangalore Cab", link: "Belgaum-to-Bangalore-Cab" },
        { place: "/images/keyword/9.jpg", text: "Goa Cab Service", link: "Goa-Cab-Service" },
        { place: "/images/keyword/10.jpg", text: "Taxi Service in Goa", link: "Taxi-Service-in-Goa" },
        { place: "/images/keyword/11.jpg", text: "Cheapest Cab Service in Goa", link: "Cheapest-Cab-Service-in-Goa" },
        { place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Belgaum", link: "Corporate-Cab-Services-in-Belgaum" },
        { place: "/images/keyword/13.jpg", text: "Innova Crysta Rent in Belgaum", link: "Innova-Crysta-Rent-in-Belgaum" },
        { place: "/images/keyword/14.jpg", text: "Ertiga on Rent in Belgaum", link: "Ertiga-on-Rent-in-Belgaum" },
        { place: "/images/keyword/15.jpg", text: "Tempo Traveller Rent in Belgaum", link: "Tempo-Traveller-Rent-in-Belgaum" },
        { place: "/images/keyword/16.jpg", text: "Mini Bus Rental Belgaum", link: "Mini-Bus-Rental-Belgaum" },
        { place: "/images/keyword/17.jpg", text: "Swift Dzire on Rent in Belgaum", link: "Swift-Dzire-on-Rent-in-Belgaum" },
        { place: "/images/keyword/18.jpg", text: "Urbania on Rent in Belgaum", link: "Urbania-on-Rent-in-Belgaum" },
        { place: "/images/keyword/19.jpg", text: "Wedding Car Rental in Belgaum", link: "Wedding-Car-Rental-in-Belgaum" },
        { place: "/images/keyword/20.jpg", text: "Cabs in Belgaum", link: "Cabs-in-Belgaum" },
        { place: "/images/keyword/21.jpg", text: "Belgaum to Hubli Cab", link: "Belgaum-to-Hubli-Cab" },
        { place: "/images/keyword/22.jpg", text: "Belgaum to Dharwad Cab", link: "Belgaum-to-Dharwad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Belgaum to Kolhapur Cab", link: "Belgaum-to-Kolhapur-Cab" },
        { place: "/images/keyword/24.jpg", text: "Belgaum Airport Cab Service", link: "Belgaum-Airport-Cab-Service" },
        { place: "/images/keyword/25.jpg", text: "Belgaum to Bagalkot Cab", link: "Belgaum-to-Bagalkot-Cab" },
    ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Belgaum to Pan India Cab Service",
  "image": "https://www.belgaumtaxiservice.com/assets/images/belgaum-to-pan-india-cab-service.webp",
  "description":
    "Book Belgaum to Pan India Cab Service with Belgaum Taxi Service for safe, comfortable, and affordable long-distance taxi services across India. We provide one-way and round-trip cabs from Belgaum to any city with Sedan, Ertiga, SUV, Innova, and Innova Crysta available 24x7 for business travel, family trips, airport transfers, corporate travel, and holiday tours.",
  "brand": {
    "@type": "Brand",
    "name": "Belgaum Taxi Service"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.belgaumtaxiservice.com/belgaum-to-pan-india-cab-service"
  }
};




    return (
        <div>

<Helmet>
  <title>Belgaum to Pan India Cab Service | Nationwide Taxi Booking | +91 8722158435</title>

  <meta
    name="description"
    content="Book Belgaum to Pan India Cab Service with Belgaum Taxi Service for reliable one-way and round-trip taxi services across India. Hire Sedan, Ertiga, SUV, Innova, and Innova Crysta for affordable outstation travel, corporate trips, airport transfers, and long-distance journeys with 24x7 online cab booking."
  />

  <meta
    name="keywords"
    content="Belgaum to Pan India Cab Service, Pan India Cab Service from Belgaum, Belgaum Outstation Cab Service, Belgaum All India Taxi Service, Belgaum Long Distance Cab, Belgaum One Way Cab, Belgaum Round Trip Taxi, Belgaum Cab Booking, Belgaum Taxi Booking, Belgaum Car Rental, Belgaum Outstation Taxi, Belgaum Intercity Cab, Belgaum Nationwide Taxi Service, Belgaum Taxi for All India, Online Cab Booking Belgaum"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>






            <div className="page-headder bg-section parallaxie">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="page-header-box text-white">
                                <h1 className="text-anime-style-3 text-center text-white">
                                    {cardData.keyword}
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>













            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/60.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Belgaum Taxi Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Belgaum Taxi Service</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Belgaum Taxi Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918722158435 " className="pc-call">+91 8722158435 </a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/918722158435 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918722158435 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@belgaumtaxiservice.com" className="pc-email">
                                            booking@belgaumtaxiservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Belgaum Taxi Service</strong><br />
                                            P No 30 cCTS No 7023,
                                            Sector No 9 Malmaruti Anjaneya Nagar,
                                            Belgaum, Karnataka - 590017




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Belgaumtopanindiacabservice ;